'use client';
import { useTranslations } from 'next-intl';
import { ComponentProps } from 'react';
import { useGetLocalizedValue } from '@/shared/lib/hooks/useGetLocalizedValue';
import { LocalizedString } from '@/shared/model/Language';
import { ClientMDXRenderer } from '@/shared/ui/client-mdx-renderer';
import { Layout } from '@/shared/ui/layout';

type Props = ComponentProps<typeof Layout> & {
    text: LocalizedString | string;
    mdx?: boolean;
};

export const LocalizedText = ({ text, media, mdx = false, element, ...props }: Props) => {
    const t = useTranslations();
    const getLocalizedValue = useGetLocalizedValue();

    const resolved = typeof text === 'string' ? t(text as Parameters<typeof t>[0]) : getLocalizedValue(text);

    return (
        <Layout
            element={element ?? (mdx ? 'div' : 'span')}
            media={{ ...media, initial: { display: undefined, flexDirection: undefined, ...media?.initial } }}
            {...props}
        >
            {mdx && resolved ? <ClientMDXRenderer content={resolved} /> : resolved}
        </Layout>
    );
};
